query WfaSessions(
	$offset: Int!
	$limit: Int!
	$sort: wfa_session_runsSort
	$textSearch: wfa_session_runsSearchInsensitive
	$daysAmountFilter: ConditionInt
	$createdByFilter: ConditionString
	$customFieldsFilter: ConditionStringArray
) {
	wfa_session_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		run_id
		session_name
		total_issues
		critical_issues
		run_time
		user_name
		custom_fields
	}
	total: wfa_session_runs(
		text_contains: $textSearch
		run_time_last_n_days: $daysAmountFilter
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		run_id_count
	}
	unfiltered_total: wfa_session_runs {
		run_id_count
	}
}
